import { startOfWeek, startOfMonth, endOfWeek, formatISO } from 'date-fns';
import { useState } from 'react';
import { endOfMonth } from 'date-fns';
import { START_OF_WEEK } from '../../../constents';

export default function Period({ periodFilter, setPeriodFilter }) {
  const [day, setDay] = useState(periodFilter.name === 'day' ? true : false);
  const [week, setWeek] = useState(periodFilter.name === 'week' ? true : false);
  const [month, setMonth] = useState(
    periodFilter.name === 'month' ? true : false
  );

  const dateDispatch = (selectedPeriod, startDate, endDate) => {
    setPeriodFilter({
      name: selectedPeriod,
      startDate,
      endDate,
    });
  };
  const handlePeriodClick = (selectedPeriod) => {
    if (selectedPeriod === 'day') {
      setDay(true);
      setWeek(false);
      setMonth(false);
      dateDispatch(
        selectedPeriod,
        formatISO(new Date()),
        formatISO(new Date())
      );
    } else if (selectedPeriod === 'week') {
      setDay(false);
      setWeek(true);
      setMonth(false);
      const startDate = formatISO(startOfWeek(new Date(), START_OF_WEEK));
      const endDate = formatISO(endOfWeek(new Date(), START_OF_WEEK));
      dateDispatch(selectedPeriod, startDate, endDate);
    } else if (selectedPeriod === 'month') {
      setDay(false);
      setWeek(false);
      setMonth(true);
      const startDate = formatISO(startOfMonth(new Date()));
      const endDate = formatISO(endOfMonth(new Date()));

      dateDispatch(selectedPeriod, startDate, endDate);
    }
  };
  return (
    <div className="appt-d-display-lbl">
      <span
        className={`d-sec ${day ? 'selected-cal' : ''}`}
        onClick={() => handlePeriodClick('day')}
      >
        Day
      </span>
      <span
        className={`d-sec ${week ? 'selected-cal' : ''}`}
        onClick={() => handlePeriodClick('week')}
      >
        Week
      </span>
      <span
        className={`d-sec ${month ? 'selected-cal' : ''}`}
        onClick={() => handlePeriodClick('month')}
      >
        Month
      </span>
    </div>
  );
}
